import i18n from '@i18next/i18n';
import Snackbar from '@tencent/dui/lib/components/Snackbar';

let snackbarShown = false;

export function show3dDisabledSnackbarOnce(): void {
    if (!snackbarShown) {
        Snackbar.show({
            type: 'info',
            message: i18n.t('浏览器硬件加速已关闭，暂不支持显示三维形状。'),
            duration: 6000,
        });
        snackbarShown = true;
    }
}
